// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AllApps_draftBadge__HBzfx {
  background-color: #ff9800;
  color: var(--white-color);
  font-size: 14px;
  padding: 5px 12px;
  border-radius: 3px;
  margin-left: 8px;
  vertical-align: middle;
}

.AllApps_liveBadge__ZM5Ck {
  background-color: greenyellow;
  color: var(--white-color);
  font-size: 12px;
  font-weight: bold;
  padding: 4px 12px;
  border-radius: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-radius: 0px 10px;
  box-shadow:
    rgb(121 239 57 / 0.3) 5px 5px,
    rgb(199 255 89 / 0.4) 10px 10px,
    rgb(255 255 255 / 5%) 25px 25px;
}

.AllApps_trainingLabel__OzWQa.AllApps_untrained__iKJox {
  color: #ff9800; /* Orange color for untrained */
  background-color: #fff3e0; /* Light orange background */
}

.AllApps_trainingLabel__OzWQa.AllApps_training__TWx6d {
  color: #ff9800; /* Orange for in-progress training */
  background-color: #fff3e0;
}

.AllApps_trainingLabel__OzWQa.AllApps_trained__O-o\\+N {
  color: #0bb712; /* Green for trained */
  background-color: #e8f5e9; /* Light green background */
}

.AllApps_trainingLabel__OzWQa.AllApps_error__v2syg {
  color: #f44336; /* Red for error */
  background-color: #ffebee; /* Light red background */
}

.AllApps_trainingLabel__OzWQa.AllApps_unknown__ne40w {
  color: #9e9e9e; /* Gray for unknown */
  background-color: #f5f5f5; /* Light gray background */
}

/* Keep the draft style if needed */
.AllApps_trainingLabel__OzWQa.AllApps_drafted__SUBNK {
  color: #ff9800;
  background-color: #fff3e0;
}

.AllApps_contents__2eMVG {
  margin-top: 20px;
  /* background-color: pink; */
  display: flex;
  flex-direction: column;
}

.AllApps_topContainent__UQh5V {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 65px;
  border-bottom: 1px solid #ccc;
  padding: 20px;
}
.AllApps_topLeft__uJDxC {
  width: 50px;
  height: 40px;
  background-color: var(--primary);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  color: var(--white-color);
  border-radius: 5px;
  cursor: pointer;
}
.AllApps_topRight__P-qqH {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
}
.AllApps_search_adduser__2g7zl {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.AllApps_searchContainer__e-3NJ {
  position: relative;
  align-items: center;
  color: var(--dark-color);
  display: flex;
  gap: 10px;
}
.AllApps_searchIcon__5OmLv {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 20px;
}
.AllApps_searchInput__WulEk {
  height: 48px;
  outline: none;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  padding-left: 36px;
  width: 350px;
}
.AllApps_category__jadNY {
  font-size: 26px;
  padding: 9px 14px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  color: var(--primary-color);
  outline: none;
  border: none;
  cursor: pointer;
  background-color: transparent;
  border: 1px solid #7a9fff;
}
.AllApps_addUser__l0vLM {
  display: flex;
  align-items: center;
  justify-content: center;
  /* padding: 8px 16px; */
  border-radius: 5px;
  gap: 5px;
  cursor: pointer;
}
.AllApps_userBtn__ZN5bk {
  outline: none;
  border: none;
  font-size: 18px;
  font-weight: 500;
  color: var(--primary-color);
  background-color: transparent;
  cursor: pointer;
}

.AllApps_all_application__zHo\\+O {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background-color: transparent;
  margin-top: 35px;
}
.AllApps_noAppsWrapper__g5LLW {
  width: 100%;
  min-height: 620px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  /* justify-content: center; */
}
.AllApps_noAppsWrapper__g5LLW h2 {
  margin-bottom: 0px;
  color: var(--dark2-color);
}
.AllApps_noAppsIcon__OY-pA {
  width: 260px;
  margin-bottom: 26px;
  opacity: 0.9;
}

.AllApps_noAppsWrapper__g5LLW p {
  color: #777;
  margin: 8px 0 16px;
}
.AllApps_noAppsWrapper__g5LLW .AllApps_userBtn__ZN5bk {
  outline: none;
  border: none;
  font-size: 18px;
  font-weight: 500;
  background-color: var(--primary-color);
  color: var(--white-color);
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 25px;
  border-radius: 4px;
}
.AllApps_noAppsWrapper__g5LLW .AllApps_adduserIc__aiLBh {
  color: var(--white-color);
}
.AllApps_mycard__7iFFm {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: space-evenly;
  padding: 20px;
  border: 1px solid #e2e2e2;
  border-radius: 6px;
  border-radius: 10px;
  background: var(--gradient-bg);
}

.AllApps_firstApp_card__Amlox {
  overflow: hidden;
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease,
    background 0.3s ease;
  width: 305px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;
  border: 1px solid #e3e6ea;
  position: relative;
  background: var(--white-color);
  border: 1px solid #e2e2e2;
  border-radius: 6px;
  padding: 16px;
  box-shadow: var(--shadow-md);
}

.AllApps_firstApp_card__Amlox:hover {
  transform: scale(1.03);
  border: 1px solid #7a9fff;
}
.AllApps_deleteAppIc__Fy178 {
  position: absolute;
  bottom: 35px;
  right: 15px;
  cursor: pointer;
  width: 38px;
  border-radius: 50%;
  height: 38px;
  background: #ffe9e9;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 2px;
}
.AllApps_cardbg__YrKNv {
  text-decoration: none;
}
.AllApps_cardbg__YrKNv h3 {
  font-size: 1.4rem;
  font-weight: 600;
  color: var(--heading);
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.AllApps_appIds__pUMQK {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.AllApps_appType_region__4vSiQ {
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  background-color: #f9fbfd;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.AllApps_styleLine__Ae20b {
  height: 30px;
  color: #ccc;
  border-radius: 50px;
  border: 1px solid;
}
.AllApps_app_id__LHDtT {
  padding: 10px;

  text-align: left;
  font-size: 0.9rem;
}

.AllApps_role__Ovn6u {
  background-color: #ebf1ff;
  /* background-color: var(--icon2-bg-color); */
  padding: 12px;
  border-radius: 8px;
  font-size: 1rem;
  margin-top: 16px;
  font-weight: 500;
  text-align: left;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.05);
  min-width: 220px;
  max-width: 100%;
  width: 80%;
}

.AllApps_idHeading__AnAi9 {
  font-size: 0.85rem;
  color: #8a9cae;
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.AllApps_table-container__tELdi {
  width: 100%;
  color: var(--dark-color);
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.AllApps_table__L7s6L {
  border-collapse: collapse;
  width: 100%;
  border-radius: 5px;
  overflow: hidden;
  min-width: 600px;
}
.AllApps_table__L7s6L th,
.AllApps_table__L7s6L td {
  padding: 12px;
  text-align: left;
  font-size: 16px;
  font-weight: 400;
  height: 58px;
  border: none;
}

.AllApps_table__L7s6L th {
  background-color: #f9f9f9;
  color: var(--dark-color);
  font-size: 16px;
  font-weight: 600;
  /* border-radius: 15px 15px 0px 0px; */
}
.AllApps_table__L7s6L tr:hover td {
  background-color: #ebf1ff;
}

tbody tr:hover {
  background-color: #f1f1f1;
}
tr:nth-child(even) {
  background-color: #f9f9f9;
  position: relative;
}
tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

tbody tr:hover {
  background-color: #f1f1f1;
}
.AllApps_adduserIc__aiLBh {
  font-size: 24px;
  color: var(--primary-color);
}
.AllApps_aiBotEnabled__ABI1D {
  background-color: #efdbff;
  color: var(--white-color);
  border: none;
  width: 45px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  height: 45px;
  border-radius: 50%;
}
.AllApps_aiBotEnabled__ABI1D:hover {
  background-color: #e1b8ff;
}

.AllApps_aiBotDisabled__JW0cr {
  background-color: #e0e0e0;
  color: #888;
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  cursor: not-allowed;
  width: 45px;
  height: 45px;
  border-radius: 50%;
}
.AllApps_tooltipWrapper__AxfsJ {
  position: relative;
  display: inline-block;
}
.AllApps_tooltipText__ZT4lV {
  visibility: hidden;
  background-color: #333;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 6px 8px;
  position: fixed;
  z-index: 9999;
  opacity: 0;
  transition: opacity 0.2s ease;
  font-size: 12px;
  pointer-events: none;
  transform: translate(-70%, -38px);
}

.AllApps_tooltipWrapper__AxfsJ:hover .AllApps_tooltipText__ZT4lV {
  visibility: visible;
  opacity: 1;
}
.AllApps_tooltipText__ZT4lV::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #333 transparent transparent transparent;
}
.AllApps_chatTypes__evlo3 {
  display: flex;
  gap: 25px;
  justify-content: start;
}
.AllApps_iconWrapper__hnwv\\+ {
  position: relative;
  display: inline-block;
}

.AllApps_disabledOverlay__96R8C::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 2px;
  background: red;
  transform: rotate(-45deg);
  transform-origin: center;
  pointer-events: none;
}

.AllApps_disabledOverlay__96R8C::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 2px;
  background: #ff000070;
  transform-origin: center;
  pointer-events: none;
}

.AllApps_disabledOverlay__96R8C::before {
  transform: rotate(45deg);
}

/* .disabledOverlay::after {
  transform: rotate(-45deg);
} */

@media (max-width: 768px) {
  .AllApps_firstApp_card__Amlox {
    width: 100%;
  }
  .AllApps_table__L7s6L {
    font-size: 14px;
  }
}
@media screen and (max-width: 480px) {
  .AllApps_search_adduser__2g7zl {
    display: block;
  }
  /* .category {
    padding: 9px 12px;
  } */
  .AllApps_addUser__l0vLM {
    margin-top: 30px;
    height: 48px;
    background-color: var(--primary-color);
  }
  .AllApps_userBtn__ZN5bk {
    color: var(--white-color);
  }
  .AllApps_adduserIc__aiLBh {
    color: var(--white-color);
  }
  .AllApps_searchInput__WulEk {
    width: 315px;
  }
  .AllApps_app_id__LHDtT {
    display: flex;
    gap: 10px;
    padding: 10px 16px;
  }
  .AllApps_role__Ovn6u {
    display: flex;
    gap: 10px;
  }
  .AllApps_firstApp_card__Amlox {
    padding: 10px;
    border-radius: 10px;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  }
}

@media (max-width: 368px) {
  .AllApps_searchInput__WulEk {
    width: 265px;
  }
  .AllApps_deleteAppIc__Fy178 {
    bottom: 15px;
  }
  .AllApps_role__Ovn6u {
    min-width: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/Apps/AllApps.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB;;;mCAGiC;AACnC;;AAEA;EACE,cAAc,EAAE,+BAA+B;EAC/C,yBAAyB,EAAE,4BAA4B;AACzD;;AAEA;EACE,cAAc,EAAE,oCAAoC;EACpD,yBAAyB;AAC3B;;AAEA;EACE,cAAc,EAAE,sBAAsB;EACtC,yBAAyB,EAAE,2BAA2B;AACxD;;AAEA;EACE,cAAc,EAAE,kBAAkB;EAClC,yBAAyB,EAAE,yBAAyB;AACtD;;AAEA;EACE,cAAc,EAAE,qBAAqB;EACrC,yBAAyB,EAAE,0BAA0B;AACvD;;AAEA,mCAAmC;AACnC;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,6BAA6B;EAC7B,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,aAAa;EACb,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB;;;wBAGsB;EACtB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;AAC5C;AACA;EACE,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,2CAA2C;EAC3C,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,aAAa;;EAEb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,6CAA6C;EAC7C,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,sCAAsC;EACtC,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,UAAU;EACV,6BAA6B;EAC7B,eAAe;EACf,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,sDAAsD;AACxD;AACA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,WAAW;EACX,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,WAAW;EACX,WAAW;EACX,qBAAqB;EACrB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;GAEG;;AAEH;EACE;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,cAAc;EAChB;EACA;;KAEG;EACH;IACE,gBAAgB;IAChB,YAAY;IACZ,sCAAsC;EACxC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;IACb,SAAS;IACT,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,SAAS;EACX;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,2CAA2C;EAC7C;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF","sourcesContent":[".draftBadge {\n  background-color: #ff9800;\n  color: var(--white-color);\n  font-size: 14px;\n  padding: 5px 12px;\n  border-radius: 3px;\n  margin-left: 8px;\n  vertical-align: middle;\n}\n\n.liveBadge {\n  background-color: greenyellow;\n  color: var(--white-color);\n  font-size: 12px;\n  font-weight: bold;\n  padding: 4px 12px;\n  border-radius: 4px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border-radius: 0px 10px;\n  box-shadow:\n    rgb(121 239 57 / 0.3) 5px 5px,\n    rgb(199 255 89 / 0.4) 10px 10px,\n    rgb(255 255 255 / 5%) 25px 25px;\n}\n\n.trainingLabel.untrained {\n  color: #ff9800; /* Orange color for untrained */\n  background-color: #fff3e0; /* Light orange background */\n}\n\n.trainingLabel.training {\n  color: #ff9800; /* Orange for in-progress training */\n  background-color: #fff3e0;\n}\n\n.trainingLabel.trained {\n  color: #0bb712; /* Green for trained */\n  background-color: #e8f5e9; /* Light green background */\n}\n\n.trainingLabel.error {\n  color: #f44336; /* Red for error */\n  background-color: #ffebee; /* Light red background */\n}\n\n.trainingLabel.unknown {\n  color: #9e9e9e; /* Gray for unknown */\n  background-color: #f5f5f5; /* Light gray background */\n}\n\n/* Keep the draft style if needed */\n.trainingLabel.drafted {\n  color: #ff9800;\n  background-color: #fff3e0;\n}\n\n.contents {\n  margin-top: 20px;\n  /* background-color: pink; */\n  display: flex;\n  flex-direction: column;\n}\n\n.topContainent {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 65px;\n  border-bottom: 1px solid #ccc;\n  padding: 20px;\n}\n.topLeft {\n  width: 50px;\n  height: 40px;\n  background-color: var(--primary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 32px;\n  color: var(--white-color);\n  border-radius: 5px;\n  cursor: pointer;\n}\n.topRight {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n}\n.search_adduser {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.searchContainer {\n  position: relative;\n  align-items: center;\n  color: var(--dark-color);\n  display: flex;\n  gap: 10px;\n}\n.searchIcon {\n  position: absolute;\n  left: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 20px;\n}\n.searchInput {\n  height: 48px;\n  outline: none;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 16px;\n  padding-left: 36px;\n  width: 350px;\n}\n.category {\n  font-size: 26px;\n  padding: 9px 14px;\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  color: var(--primary-color);\n  outline: none;\n  border: none;\n  cursor: pointer;\n  background-color: transparent;\n  border: 1px solid #7a9fff;\n}\n.addUser {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* padding: 8px 16px; */\n  border-radius: 5px;\n  gap: 5px;\n  cursor: pointer;\n}\n.userBtn {\n  outline: none;\n  border: none;\n  font-size: 18px;\n  font-weight: 500;\n  color: var(--primary-color);\n  background-color: transparent;\n  cursor: pointer;\n}\n\n.all_application {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  background-color: transparent;\n  margin-top: 35px;\n}\n.noAppsWrapper {\n  width: 100%;\n  min-height: 620px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  /* justify-content: center; */\n}\n.noAppsWrapper h2 {\n  margin-bottom: 0px;\n  color: var(--dark2-color);\n}\n.noAppsIcon {\n  width: 260px;\n  margin-bottom: 26px;\n  opacity: 0.9;\n}\n\n.noAppsWrapper p {\n  color: #777;\n  margin: 8px 0 16px;\n}\n.noAppsWrapper .userBtn {\n  outline: none;\n  border: none;\n  font-size: 18px;\n  font-weight: 500;\n  background-color: var(--primary-color);\n  color: var(--white-color);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 25px;\n  border-radius: 4px;\n}\n.noAppsWrapper .adduserIc {\n  color: var(--white-color);\n}\n.mycard {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  justify-content: space-evenly;\n  padding: 20px;\n  border: 1px solid #e2e2e2;\n  border-radius: 6px;\n  border-radius: 10px;\n  background: var(--gradient-bg);\n}\n\n.firstApp_card {\n  overflow: hidden;\n  transition:\n    transform 0.3s ease,\n    box-shadow 0.3s ease,\n    background 0.3s ease;\n  width: 305px;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 20px;\n  border: 1px solid #e3e6ea;\n  position: relative;\n  background: var(--white-color);\n  border: 1px solid #e2e2e2;\n  border-radius: 6px;\n  padding: 16px;\n  box-shadow: var(--shadow-md);\n}\n\n.firstApp_card:hover {\n  transform: scale(1.03);\n  border: 1px solid #7a9fff;\n}\n.deleteAppIc {\n  position: absolute;\n  bottom: 35px;\n  right: 15px;\n  cursor: pointer;\n  width: 38px;\n  border-radius: 50%;\n  height: 38px;\n  background: #ffe9e9;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 2px;\n}\n.cardbg {\n  text-decoration: none;\n}\n.cardbg h3 {\n  font-size: 1.4rem;\n  font-weight: 600;\n  color: var(--heading);\n  margin-bottom: 14px;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.appIds {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.appType_region {\n  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;\n  background-color: #f9fbfd;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.styleLine {\n  height: 30px;\n  color: #ccc;\n  border-radius: 50px;\n  border: 1px solid;\n}\n.app_id {\n  padding: 10px;\n\n  text-align: left;\n  font-size: 0.9rem;\n}\n\n.role {\n  background-color: #ebf1ff;\n  /* background-color: var(--icon2-bg-color); */\n  padding: 12px;\n  border-radius: 8px;\n  font-size: 1rem;\n  margin-top: 16px;\n  font-weight: 500;\n  text-align: left;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.05);\n  min-width: 220px;\n  max-width: 100%;\n  width: 80%;\n}\n\n.idHeading {\n  font-size: 0.85rem;\n  color: #8a9cae;\n  margin-bottom: 6px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.table-container {\n  width: 100%;\n  color: var(--dark-color);\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n.table {\n  border-collapse: collapse;\n  width: 100%;\n  border-radius: 5px;\n  overflow: hidden;\n  min-width: 600px;\n}\n.table th,\n.table td {\n  padding: 12px;\n  text-align: left;\n  font-size: 16px;\n  font-weight: 400;\n  height: 58px;\n  border: none;\n}\n\n.table th {\n  background-color: #f9f9f9;\n  color: var(--dark-color);\n  font-size: 16px;\n  font-weight: 600;\n  /* border-radius: 15px 15px 0px 0px; */\n}\n.table tr:hover td {\n  background-color: #ebf1ff;\n}\n\ntbody tr:hover {\n  background-color: #f1f1f1;\n}\ntr:nth-child(even) {\n  background-color: #f9f9f9;\n  position: relative;\n}\ntbody tr:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\ntbody tr:hover {\n  background-color: #f1f1f1;\n}\n.adduserIc {\n  font-size: 24px;\n  color: var(--primary-color);\n}\n.aiBotEnabled {\n  background-color: #efdbff;\n  color: var(--white-color);\n  border: none;\n  width: 45px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  height: 45px;\n  border-radius: 50%;\n}\n.aiBotEnabled:hover {\n  background-color: #e1b8ff;\n}\n\n.aiBotDisabled {\n  background-color: #e0e0e0;\n  color: #888;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 6px;\n  cursor: not-allowed;\n  width: 45px;\n  height: 45px;\n  border-radius: 50%;\n}\n.tooltipWrapper {\n  position: relative;\n  display: inline-block;\n}\n.tooltipText {\n  visibility: hidden;\n  background-color: #333;\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 6px 8px;\n  position: fixed;\n  z-index: 9999;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n  font-size: 12px;\n  pointer-events: none;\n  transform: translate(-70%, -38px);\n}\n\n.tooltipWrapper:hover .tooltipText {\n  visibility: visible;\n  opacity: 1;\n}\n.tooltipText::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: #333 transparent transparent transparent;\n}\n.chatTypes {\n  display: flex;\n  gap: 25px;\n  justify-content: start;\n}\n.iconWrapper {\n  position: relative;\n  display: inline-block;\n}\n\n.disabledOverlay::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 0;\n  width: 100%;\n  height: 2px;\n  background: red;\n  transform: rotate(-45deg);\n  transform-origin: center;\n  pointer-events: none;\n}\n\n.disabledOverlay::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 0;\n  width: 100%;\n  height: 2px;\n  background: #ff000070;\n  transform-origin: center;\n  pointer-events: none;\n}\n\n.disabledOverlay::before {\n  transform: rotate(45deg);\n}\n\n/* .disabledOverlay::after {\n  transform: rotate(-45deg);\n} */\n\n@media (max-width: 768px) {\n  .firstApp_card {\n    width: 100%;\n  }\n  .table {\n    font-size: 14px;\n  }\n}\n@media screen and (max-width: 480px) {\n  .search_adduser {\n    display: block;\n  }\n  /* .category {\n    padding: 9px 12px;\n  } */\n  .addUser {\n    margin-top: 30px;\n    height: 48px;\n    background-color: var(--primary-color);\n  }\n  .userBtn {\n    color: var(--white-color);\n  }\n  .adduserIc {\n    color: var(--white-color);\n  }\n  .searchInput {\n    width: 315px;\n  }\n  .app_id {\n    display: flex;\n    gap: 10px;\n    padding: 10px 16px;\n  }\n  .role {\n    display: flex;\n    gap: 10px;\n  }\n  .firstApp_card {\n    padding: 10px;\n    border-radius: 10px;\n    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;\n  }\n}\n\n@media (max-width: 368px) {\n  .searchInput {\n    width: 265px;\n  }\n  .deleteAppIc {\n    bottom: 15px;\n  }\n  .role {\n    min-width: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"draftBadge": `AllApps_draftBadge__HBzfx`,
	"liveBadge": `AllApps_liveBadge__ZM5Ck`,
	"trainingLabel": `AllApps_trainingLabel__OzWQa`,
	"untrained": `AllApps_untrained__iKJox`,
	"training": `AllApps_training__TWx6d`,
	"trained": `AllApps_trained__O-o+N`,
	"error": `AllApps_error__v2syg`,
	"unknown": `AllApps_unknown__ne40w`,
	"drafted": `AllApps_drafted__SUBNK`,
	"contents": `AllApps_contents__2eMVG`,
	"topContainent": `AllApps_topContainent__UQh5V`,
	"topLeft": `AllApps_topLeft__uJDxC`,
	"topRight": `AllApps_topRight__P-qqH`,
	"search_adduser": `AllApps_search_adduser__2g7zl`,
	"searchContainer": `AllApps_searchContainer__e-3NJ`,
	"searchIcon": `AllApps_searchIcon__5OmLv`,
	"searchInput": `AllApps_searchInput__WulEk`,
	"category": `AllApps_category__jadNY`,
	"addUser": `AllApps_addUser__l0vLM`,
	"userBtn": `AllApps_userBtn__ZN5bk`,
	"all_application": `AllApps_all_application__zHo+O`,
	"noAppsWrapper": `AllApps_noAppsWrapper__g5LLW`,
	"noAppsIcon": `AllApps_noAppsIcon__OY-pA`,
	"adduserIc": `AllApps_adduserIc__aiLBh`,
	"mycard": `AllApps_mycard__7iFFm`,
	"firstApp_card": `AllApps_firstApp_card__Amlox`,
	"deleteAppIc": `AllApps_deleteAppIc__Fy178`,
	"cardbg": `AllApps_cardbg__YrKNv`,
	"appIds": `AllApps_appIds__pUMQK`,
	"appType_region": `AllApps_appType_region__4vSiQ`,
	"styleLine": `AllApps_styleLine__Ae20b`,
	"app_id": `AllApps_app_id__LHDtT`,
	"role": `AllApps_role__Ovn6u`,
	"idHeading": `AllApps_idHeading__AnAi9`,
	"table-container": `AllApps_table-container__tELdi`,
	"table": `AllApps_table__L7s6L`,
	"aiBotEnabled": `AllApps_aiBotEnabled__ABI1D`,
	"aiBotDisabled": `AllApps_aiBotDisabled__JW0cr`,
	"tooltipWrapper": `AllApps_tooltipWrapper__AxfsJ`,
	"tooltipText": `AllApps_tooltipText__ZT4lV`,
	"chatTypes": `AllApps_chatTypes__evlo3`,
	"iconWrapper": `AllApps_iconWrapper__hnwv+`,
	"disabledOverlay": `AllApps_disabledOverlay__96R8C`
};
export default ___CSS_LOADER_EXPORT___;
